import { useEffect, useState } from "react";
import { tableService } from "../../../services/tableService";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import Loader from "../../shared/Loader";
import LiveOrdersTables from "./LiveOrdersTables";
import { useParams } from "react-router-dom";
import { useNotification } from "../../toster-notification/NotificationContext";
import { LiveOrderTableDTO } from "../../../models/table/table.response";
import TableInfoModalView from "./TableInfoModalView";
import { connection, startConnection } from "../../../services/signalRConnection";
import { HandRedIcon } from "../../../assets/icons";
import { TableStatusType } from "../../../models/base/TableStatusType";



const LiveOrdersView1FullScreenPage: React.FC = () => {

    const [tables, setTables] = useState<LiveOrderTableDTO[]>([]);
    const [selectedTableId, setSelectedTableId] = useState<string>("");
    const [backgroundImageUrl, setBackgroundImageUrl] = useState<string>("");
    const [isTavleInfoViewOpen, setIsTableInfoViewOpen] = useState(false);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    const { localId } = useParams<{ localId: string }>();


    useEffect(() => {
        fetchTables();
        fetchBackgroundImage();
    }, []);

    useEffect(() => {

        const handler = (tableId: string) => {
            console.log("Tables table status with id:" + tableId);
            fetchTable(tableId);
        };

        const setup = async () => {
            await startConnection();
            await connection.invoke<void>("JoinTablesMonitoringGroup", localId);
            connection.on("TableStatusChange", handler);
        };

        setup();

        return () => {
            connection.off("TableStatusChange", handler);
        };

    }, [localId]);


    useEffect(() => {

        const handler = (tableId: string) => {
            notify("info", `Sto ${tableId}`, "Poziv konobara");
            setTables(prev => prev.map(table => table.id === tableId ? { ...table, callWaiter: true } : table))
        };

        const setup = async () => {
            await startConnection();
            await connection.invoke<void>("JoinCallWaiterAsync", localId);
            connection.on("CallWaiter", handler);
        };

        setup();

        return () => {
            connection.off("CallWaiter", handler);
        };

    }, [localId]);

    const waiterReceiveAsync = async (tableId: string) => {

        if (tableId == null || localId == null)
            return;

        await startConnection();
        await connection.invoke<void>("WaiterReceiveAsync", localId, tableId)

    }

    const fetchBackgroundImage = async () => {
        if (!localId) {
            notify("error", "Local ID nije prosleđen");
            return;
        }

        try {
            const response = await tableService.getBackgroundImage(localId);
            if (response.success && response.data) {
                setBackgroundImageUrl(response.data);
            } else {
                notify("error", "Greška pri učitavanju pozadine", response.message || "Došlo je do greške pri učitavanju pozadine.");
            }
        } catch (error: any) {
            notify("error", "Greška pri učitavanju pozadine", "Došlo je do greške pri učitavanju pozadine.");
            handleErrorNotification(error, notify);
            console.error("Error fetching background image:", error);
        }
    };

    const fetchTable = async (tableId: string) => {

        if (!localId) {
            notify("error", "Local ID nije prosledjen");
            return;
        }

        try {
            const response = await tableService.getLiveOrdersTableByLocalId(localId, tableId);

            if (response.success && response.data) {
                const updatedTable = response.data;
                setTables(prev => [...prev.filter(t => t.id !== tableId), updatedTable]);
            } else {
                notify("error", "Greška pri učitavanju stola", response.message || "Došlo je do greške pri učitavanju stola.");

            }
        } catch (error: any) {
            notify("error", "Greška pri učitavanju stola", "Došlo je do greške pri učitavanju stola.");
            handleErrorNotification(error, notify);
            console.error("Error fetching tables:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchTables = async () => {
        if (!localId) {
            notify("error", "Local ID nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await tableService.getLiveOrdersTablesByLocalId(localId);

            if (response.success && response.data) {
                setTables(response.data);
            } else {
                notify("error", "Greška pri učitavanju stolova", response.message || "Došlo je do greške pri učitavanju stolova.");

            }
        } catch (error: any) {
            notify("error", "Greška pri učitavanju stolova", "Došlo je do greške pri učitavanju stolova.");
            handleErrorNotification(error, notify);
            console.error("Error fetching tables:", error);
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <Loader />;
    }

    return (
        <>

            {isTavleInfoViewOpen && selectedTableId && (
                <TableInfoModalView
                    selectedTableId={selectedTableId}
                    onClose={() => {
                        setIsTableInfoViewOpen(false)
                        fetchTables();
                    }}
                    isCallWaiter={tables.some(t => t.id === selectedTableId && t.callWaiter === true)}
                    onWaiterReceive={(tableId) => {
                        setTables(prev => prev.map(t => t.id === tableId ? { ...t, callWaiter: false } : t));
                        waiterReceiveAsync(tableId);
                    }}
                />
            )}

            <section className="live-order-view1-section">
                <div className="w-layout-blockcontainer container live-order-main w-container">
                    <div className="live-order-main-wrapper">
                        <div className="tables-status-layout">
                            <div className="lo-status-list">
                                <div id="w-node-_784b75b9-7580-94fe-59b3-83eda507705e-1cee91cf" className="admin-settings-box-div">
                                    <div className="lo-status-header-div">
                                        <div>Slobodno</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info free"></div>
                                        <div>{tables.filter(t => t.currentStatus === TableStatusType.Free).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div">
                                    <div className="lo-status-header-div">
                                        <div>Poručeno</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info ordered"></div>
                                        <div>{tables.filter(t => t.currentStatus === TableStatusType.Ordered).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div">
                                    <div className="lo-status-header-div">
                                        <div>Primljeno</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info recived"></div>
                                        <div>{tables.filter(t => t.currentStatus === TableStatusType.Recived).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div">
                                    <div className="lo-status-header-div">
                                        <div>Usluženo</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info served"></div>
                                        <div>{tables.filter(t => t.currentStatus === TableStatusType.Served).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div">
                                    <div className="lo-status-header-div">
                                        <div>Račun</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info bill"></div>
                                        <div>{tables.filter(t => t.currentStatus === TableStatusType.Bill).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div">
                                    <div className="lo-status-header-div">
                                        <div>Plaćeno</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info paid"></div>
                                        <div className="text-block-16">{tables.filter(t => t.currentStatus === TableStatusType.Paid).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div red-bg">
                                    <div className="lo-status-header-div">
                                        <div>
                                            Pozivi konobara<br />
                                        </div>
                                    </div>
                                    <div className="lo-status-block">
                                        <img loading="lazy" src={HandRedIcon} alt="" className="icon-size-24" />
                                        <div className="text-block-16">{tables.filter(t => t.callWaiter === true).length}</div>
                                    </div>
                                </div>
                            </div>

                            <LiveOrdersTables
                                tables={tables}
                                disablePositioning={true}
                                onSelectedTableChange={(tableId) => {
                                    setSelectedTableId(tableId);
                                    setIsTableInfoViewOpen(true)
                                }}
                                backgroundImageUrl={backgroundImageUrl + "@ul.webp"}
                            />

                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default LiveOrdersView1FullScreenPage;